var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.01 7.49C26.77 7.37 26.54 7.23 26.32 7.09C25.67 6.66 25.08 6.16 24.55 5.59C23.23 4.08 22.74 2.55 22.56 1.48H22.57C22.41 0.58 22.47 0 22.48 0H16.47V23.24C16.47 23.55 16.47 23.86 16.46 24.17C16.46 24.21 16.46 24.24 16.45 24.28C16.45 24.3 16.45 24.31 16.45 24.33V24.34C16.32 26.03 15.36 27.55 13.88 28.39C13.12 28.82 12.26 29.05 11.39 29.05C8.59 29.05 6.32 26.77 6.32 23.95C6.32 21.13 8.59 18.85 11.39 18.85C11.92 18.85 12.45 18.93 12.95 19.1L12.96 12.98C9.87 12.58 6.75 13.49 4.36 15.5C3.32 16.4 2.45 17.47 1.79 18.67C1.54 19.11 0.579995 20.87 0.459995 23.72C0.389995 25.34 0.869997 27.02 1.11 27.71V27.72C1.26 28.13 1.81999 29.52 2.73999 30.7C3.47999 31.64 4.35999 32.47 5.33999 33.16V33.15L5.34999 33.16C8.25999 35.14 11.49 35.01 11.49 35.01C12.05 34.99 13.92 35.01 16.04 34C18.4 32.88 19.74 31.22 19.74 31.22C20.6 30.23 21.28 29.09 21.76 27.87C22.3 26.44 22.49 24.73 22.49 24.04V11.7C22.56 11.74 23.53 12.39 23.53 12.39C23.53 12.39 24.93 13.29 27.11 13.87C28.68 14.29 30.79 14.37 30.79 14.37V8.4C30.05 8.48 28.54 8.25 27.01 7.49Z",
    fill: "url(#paint0_linear_18_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_11",
    x1: -73.8195,
    y1: 107.55,
    x2: 127.514,
    y2: -93.7831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.6f30d688850a04c83b6438ca63667faa.svg";
export { ForwardRef as ReactComponent };